/*
 *
 * Login reducer
 *
 */
import produce from 'immer';
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_ERROR,
  FLUSH_STATE,
} from './constants';

export const initialState = {
  authenticated: false,
  loading: false,
  error: false,
  currentUser: false,
  loginValues: false,
  isApp: false,
};


/* eslint-disable default-case, no-param-reassign */
const loginReducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case FLUSH_STATE:
        return initialState;
      
      case LOGIN_USER:
        draft.loading = true;
        draft.error = false;
        draft.loginValues = action.loginValues;
        draft.isApp = action.isApp;
        break;

      case LOGIN_USER_SUCCESS:
        draft.loading = false;
        draft.currentUser = action.currentUser;
        draft.authenticated = action.authenticated;
        break;

      case LOGIN_USER_ERROR:
        draft.error = action.error;
        draft.loading = false;
        draft.authenticated = false;
        draft.currentUser = false;
        break;
    
    }
  });

export default loginReducer;
